'use client';

import { Trophy, Users, Globe, MapPin, UserRound } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { cn } from '@/lib/utils';

export type LeaderboardTab = 'participants' | 'passengers' | 'teams' | 'countries' | 'cities';

const tabDefs: { id: LeaderboardTab; labelKey: string; icon: typeof Trophy }[] = [
  { id: 'participants', labelKey: 'tabParticipants', icon: Trophy },
  { id: 'passengers', labelKey: 'tabPassengers', icon: UserRound },
  { id: 'teams', labelKey: 'tabTeams', icon: Users },
  { id: 'countries', labelKey: 'tabCountries', icon: Globe },
  { id: 'cities', labelKey: 'tabCities', icon: MapPin },
];

export function LeaderboardTabs({
  activeTab,
  onTabChange,
}: {
  activeTab: LeaderboardTab;
  onTabChange: (tab: LeaderboardTab) => void;
}) {
  const t = useTranslations('leaderboard');

  return (
    <div className="flex gap-1.5 overflow-x-auto scrollbar-hide">
      {tabDefs.map((tab) => {
        const Icon = tab.icon;
        const active = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            aria-current={active ? 'page' : undefined}
            className={cn(
              'flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium whitespace-nowrap rounded-lg transition-all touch-manipulation',
              active
                ? 'bg-dgd-gold text-dgd-charcoal shadow-sm'
                : 'text-stone-700 hover:text-stone-800 hover:bg-stone-100',
            )}
          >
            <Icon className="w-3.5 h-3.5" />
            <span className={cn('sm:inline', active ? 'inline' : 'hidden')}>{t(tab.labelKey)}</span>
          </button>
        );
      })}
    </div>
  );
}
